import { render } from "./EditPersonForm.vue?vue&type=template&id=05f4e176&scoped=true"
import script from "./EditPersonForm.vue?vue&type=script&lang=js"
export * from "./EditPersonForm.vue?vue&type=script&lang=js"

import "./EditPersonForm.vue?vue&type=style&index=0&id=05f4e176&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f4e176"]])

export default __exports__